import React, { useState } from 'react';
import { ShadcnUiToggleWrapper, SHADCN_UI_STORAGE_KEY } from 'feature-toggle';
import { Checkbox, Label } from 'shadcn-ui';
import { Header5 } from 'ui-builder';
import { Separator } from 'features/nekst-widgets';

function ShadcnUiToggle() {
  const [enabled, setEnabled] = useState(
    () => localStorage.getItem(SHADCN_UI_STORAGE_KEY) === 'true',
  );

  const handleChange = (checked: boolean) => {
    localStorage.setItem(SHADCN_UI_STORAGE_KEY, String(checked));
    setEnabled(checked);
    window.location.reload();
  };

  return (
    <>
      <Separator />
      <Header5>New UI</Header5>
      <Label
        htmlFor="shadcn-ui-toggle"
        className="inline-flex items-center gap-2 cursor-pointer select-none text-sm text-foreground mb-0"
      >
        <Checkbox
          id="shadcn-ui-toggle"
          checked={enabled}
          onCheckedChange={(checked) => handleChange(!!checked)}
        />
        <span>Enable New UI (experimental)</span>
      </Label>
    </>
  );
}

export default function ShadcnUiSettingsToggle() {
  return (
    <ShadcnUiToggleWrapper>
      <ShadcnUiToggle />
    </ShadcnUiToggleWrapper>
  );
}
